import {
  GET_MUSIC,
  GET_ONE_MUSIC,
  ADD_MUSIC,
  UPDATE_MUSIC,
  ERRORS,
  LOADING,
} from "./musicTypes";

const initialState = {
  musics: null,
  music: null,
  update_music: null,
  loading: null,
  errors: null,
};

export const musicReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MUSIC:
      return {
        ...state,
        musics: [...action.payload],
      };
    case GET_ONE_MUSIC:
      return {
        ...state,
        music: action.payload,
      };
    case ADD_MUSIC:
      return {
        ...state,
        musics: [action.payload, ...state.musics],
      };
    case UPDATE_MUSIC:
      return {
        ...state,
        update_music: action.payload,
      };
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ERRORS:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
};
